import script from "./BreadcrumbEllipsis.vue?vue&type=script&lang=ts&setup=true"
export * from "./BreadcrumbEllipsis.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__